import { makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    //backgroundColor: theme.palette.background.paper,
  },
  sliderTabIcons:{
    height: '50px',
  },
  image: {
    width: '100%',
  },
  contentText: {
    fontSize: '16px',
  },
  title: {
    fontSize: '20px',
  },
  innnerContentBig: {
    width: '40vw',
    margin: '0',
  },

  innnerContentSmall: {
    width: '100%',
    margin: '20px 0',
  },
  tabGrid: {
    paddingTop: 70,
    textAlign: 'left',
    display: 'flex',
    justifyContent: 'center',
    justifyItems: 'center',
  },
  tabGridSmall: {
    padding: '0',
    textAlign: 'left',
    display: 'block',
  },
  tabs: {
    // indicator:'red'
    //color: 'linear-gradient(270deg, #F3923D -0.57%, #EB7258 45.52%, #F3923D 100%)',
    //backgroundColor: 'white'
  },
  tab: {
    padding: '20px 20px',
    // color: 'linear-gradient(270deg, #F3923D -0.57%, #EB7258 45.52%, #F3923D 100%)'
    fontSize: 'calc(0.9375rem + ((1vw - 5px) * 0.6917))',
  },
  tabPanel: {
    boxShadow: 'none',
    backgroundColor: "rgba(255, 255, 255, 0)"
  }
}));